import React from "react";
import { FormattedDate } from "react-intl";
import { TableCell } from "@material-ui/core";

const RelatedServiceProviderInvitationTableCell = ({ serviceProvider }) => {
  return (
    <TableCell>
      <FormattedDate value={serviceProvider.invitationDate} />
    </TableCell>
  );
};

export default RelatedServiceProviderInvitationTableCell;
